import { Component, Input} from '@angular/core';
import { CrmEstadosService } from '../../services/crm-estados.service';
import { ConfiguracionHistorialCambioEstadoModel } from '../../models/configuracion-historial-cambio-estado.model';
import ResponseModel from '@cf-v5-workspace/utils/models/response.model';
import LogsEstadosModel from '../../models/logs-estados.model';
import { UserException, abrirModalCargando, cerrarModalCargando, isDefinedAndNotEmpty } from '@cf-v5-workspace/utils';
import { MensajeError } from '@cf-v5-workspace/messages';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-historico-estados',
	templateUrl: './historico-estados.component.html',
	styleUrls: ['./historico-estados.component.css']
})
export class HistoricoEstadosComponent {


	@Input() settings: ConfiguracionHistorialCambioEstadoModel;
	registrosHistorial: Array<LogsEstadosModel>;
	modal: NgbModalRef;

	constructor(
		private modalService: NgbModal,
		public estadosService: CrmEstadosService
	) {}

	/**
	 * Método que se encarga de abrir el modal de historico de estados
	 * @param content 
	 * @author Bvelez
	 */
	abrirHistoricoEstados(content: NgbModalRef) {
		this.modal = this.modalService.open(content, {centered: true});
		this.obtenerHistoricoEstados();
	}

	/**
	 * Método que se encarga de cerrar el modal del historico de estados
	 * @author Bvelez
	 */
	descartar(): void {
		if(isDefinedAndNotEmpty(this.modal)) {
			this.modal.close();
		}
	}

	/**
	 * Método que se encarga de obtener el historico de estados que ha tenido el documento
	 * @author Bvelez
	 */
	obtenerHistoricoEstados() {
		try {
			abrirModalCargando()
			this.estadosService.obtenerHistoricoEstados(this.settings).subscribe(
				(response: ResponseModel<Array<LogsEstadosModel>>) => {
					cerrarModalCargando();
					if (response.esExitoso == true) {
						this.registrosHistorial = response.datos;
					} else {
						MensajeError('No se logró obtener los estados');
						console.log(response);
					}
				}, error =>{
					cerrarModalCargando();
					UserException('Problema al obtener el historico de estados', error, `${this.obtenerHistoricoEstados.name}`);
					this.descartar();
				}
			);	
		} catch (error) {
			cerrarModalCargando();
			UserException('Problema al obtener el historico de estados', error, `${this.obtenerHistoricoEstados.name}` );
			this.descartar();
		}
	}



}
